// referenceSections.ts — flattens GROUPS into an ordered list of anchorable sections for the
// continuous-scroll (scrollspy) reference page. Reuses the existing `guide:<id>` / `ep:<id>` id
// convention already used by RefNav's active-item selector.
import type { EndpointData } from '@/containers/reference';

export interface GuideSection {
  kind: 'guide';
  fullId: string;
  id: string;
  groupId: string;
}

export interface EndpointSection {
  kind: 'ep';
  fullId: string;
  id: string;
  ep: EndpointData;
  groupId: string;
}

export type RefSection = GuideSection | EndpointSection;

interface GroupLike {
  id: string;
  pages?: { id: string }[];
  endpoints?: EndpointData[];
}

export function buildSections(groups: GroupLike[]): RefSection[] {
  const out: RefSection[] = [];
  for (const g of groups) {
    (g.pages ?? []).forEach((p) => out.push({ kind: 'guide', fullId: `guide:${p.id}`, id: p.id, groupId: g.id }));
    (g.endpoints ?? []).forEach((e) => out.push({ kind: 'ep', fullId: `ep:${e.id}`, id: e.id, ep: e, groupId: g.id }));
  }
  return out;
}

export function buildSlugToFullId(sections: RefSection[]): Record<string, string> {
  const map: Record<string, string> = {};
  for (const s of sections) map[s.id] = s.fullId;
  return map;
}

export function groupIdForFullId(sections: RefSection[], fullId: string | null): string | undefined {
  return sections.find((s) => s.fullId === fullId)?.groupId;
}
